<template>
  <canvas ref="canvas" style="width: 100%; display: block; margin-bottom: 8px;"></canvas>
</template>

<script>
export default {
  props: {
    doc: { required: true }, // PDFDocumentProxy do cha sở hữu
    page: { type: Number, required: true }
  },
  data() {
    return { renderTask: null, destroyed: false }
  },
  mounted() {
    this.renderPage()
  },
  beforeDestroy() {
    this.destroyed = true
    if (this.renderTask) this.renderTask.cancel() // -> huỷ render, KHÔNG destroy document -> không lag
  },
  methods: {
    async renderPage() {
      try {
        const p = await this.doc.getPage(this.page)
        if (this.destroyed) return
        const canvas = this.$refs.canvas
        const parentWidth = (canvas.parentNode && canvas.parentNode.clientWidth) || 800
        const base = p.getViewport({ scale: 1 })
        const scale = parentWidth / base.width
        const viewport = p.getViewport({ scale })
        const dpr = window.devicePixelRatio || 1
        canvas.width = Math.floor(viewport.width * dpr)
        canvas.height = Math.floor(viewport.height * dpr)
        canvas.style.height = viewport.height + 'px'
        const ctx = canvas.getContext('2d')
        this.renderTask = p.render({
          canvasContext: ctx,
          viewport,
          transform: dpr !== 1 ? [dpr, 0, 0, dpr, 0, 0] : null
        })
        await this.renderTask.promise
      } catch (e) {
        if (e && e.name !== 'RenderingCancelledException') console.error('Render trang PDF lỗi:', e)
      }
    }
  }
}
</script>
